<template>
  <div v-if="hasChildren" class="sidenav-parent">
    <a
      class="nav-link sidenav-parent-link"
      :class="{ 'is-open': isOpen, 'has-active-child': isAnyChildActive }"
      href="#"
      role="button"
      :aria-expanded="isOpen"
      @click.prevent="toggleOpen"
    >
      <div class="d-flex align-items-center w-100">
        <div class="sidenav-icon me-2 d-flex align-items-center justify-content-center">
          <i :class="faIcon"></i>
        </div>
        <span class="nav-link-text flex-grow-1">{{ navText }}</span>
        <i
          class="fas fa-chevron-right sidenav-caret"
          :class="{ rotated: isOpen }"
          aria-hidden="true"
        ></i>
      </div>
    </a>
    <ul v-show="isOpen" class="sidenav-children list-unstyled mb-0">
      <li v-for="child in children" :key="child.menuKey || child.routeName || child.menuName" class="sidenav-child-item">
        <router-link
          class="nav-link sidenav-child-link"
          :class="{ active: isChildActive(child) }"
          :to="child.to"
        >
          <div class="d-flex align-items-center">
            <span class="sidenav-child-dot me-2"></span>
            <span class="nav-link-text">{{ child.menuName }}</span>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
  <router-link v-else class="nav-link" :to="to" v-bind="$attrs">
    <div class="d-flex align-items-center">
      <div
        class="sidenav-icon me-2 d-flex align-items-center justify-content-center"
      >
        <i :class="faIcon"></i>
      </div>
      <span class="nav-link-text">{{ navText }}</span>
    </div>
  </router-link>
</template>

<script>
import { isPlanListChildActive } from "@/utils/planNav";

export default {
  name: "sidenav-collapse",
  props: {
    to: {
      type: [Object, String],
      required: false,
      default: () => ({}),
    },
    navText: {
      type: String,
      required: true,
    },
    faIcon: {
      type: String,
      default: "fas fa-circle",
    },
    children: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    hasChildren() {
      return Array.isArray(this.children) && this.children.length > 0;
    },
    isAnyChildActive() {
      if (!this.hasChildren) return false;
      return this.children.some((child) => this.isChildActive(child));
    },
  },
  watch: {
    isAnyChildActive: {
      immediate: true,
      handler(active) {
        if (active) this.isOpen = true;
      },
    },
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    isChildActive(child) {
      return isPlanListChildActive(child?.to, this.$route);
    },
  },
};
</script>

<style scoped>
.sidenav-parent-link {
  cursor: pointer;
  user-select: none;
}

.sidenav-parent-link.has-active-child {
  color: #344767;
  font-weight: 600;
}

.sidenav-caret {
  font-size: 0.65rem;
  color: #8392ab;
  transition: transform 0.2s ease;
  margin-left: 0.5rem;
}

.sidenav-caret.rotated {
  transform: rotate(90deg);
}

.sidenav-children {
  margin-top: 0.15rem;
  padding-left: 2.2rem;
}

.sidenav-child-item {
  margin: 0;
}

.sidenav-child-link {
  padding: 0.45rem 0.6rem;
  border-radius: 8px;
  font-size: 0.8rem;
  color: #67748e;
}

.sidenav-child-link:hover {
  background: #f5f7fb;
  color: #344767;
}

.sidenav-child-link.active,
.sidenav-child-link.router-link-exact-active {
  background: #344767;
  color: #ffffff !important;
  box-shadow: 0 4px 10px rgba(52, 71, 103, 0.22);
}

.sidenav-child-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.5;
  display: inline-block;
  flex-shrink: 0;
}
</style>
